/**
 * What the CRM sends today. It is explicit that Viber, Telegram and SMS are
 * likely later, so nothing here is exhaustive and nothing switches on it
 * without a fallback.
 */
const SUPPORT_CHANNEL = {
  EMAIL: 'email',
  PHONE: 'phone',
  PORTAL: 'portal',
  WHATSAPP: 'whatsapp'
} as const

/** Wording for a known channel. An unknown one keeps its own name. */
const SUPPORT_CHANNEL_LABELS: Record<string, string> = {
  [SUPPORT_CHANNEL.EMAIL]: 'Email',
  [SUPPORT_CHANNEL.PHONE]: 'Phone',
  [SUPPORT_CHANNEL.PORTAL]: 'Support portal',
  [SUPPORT_CHANNEL.WHATSAPP]: 'WhatsApp'
}

export { SUPPORT_CHANNEL, SUPPORT_CHANNEL_LABELS }
